module.exports = __webpack_public_path__ + "static/media/border-vip.27f76e94.png";